module.exports = __webpack_public_path__ + "img/xitong.6f2ee0db.png";